import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconWm = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke="none"
        strokeWidth={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.66667 13C5.64162 13 4 14.6416 4 16.6667V18H6V16.6667C6 15.7462 6.74619 15 7.66667 15H8.27235L8.47464 15.2023L7.62109 17.7629L9.04412 18.2373L9.71533 16.2236C10.086 16.3632 10.4946 16.3726 10.8704 16.2517L11.8694 18.2497L13.211 17.5789L12.079 15.3148L12.3938 15H13C13.9205 15 14.6667 15.7462 14.6667 16.6667V18H16.6667V16.6667C16.6667 14.6416 15.025 13 13 13H7.66667ZM8.66667 8.66667C8.66667 7.74619 9.41286 7 10.3333 7C11.2538 7 12 7.74619 12 8.66667C12 9.58714 11.2538 10.3333 10.3333 10.3333C9.41286 10.3333 8.66667 9.58714 8.66667 8.66667ZM10.3333 5C8.30829 5 6.66667 6.64162 6.66667 8.66667C6.66667 10.6917 8.30829 12.3333 10.3333 12.3333C12.3584 12.3333 14 10.6917 14 8.66667C14 6.64162 12.3584 5 10.3333 5ZM17.993 13.1184C19.6109 13.5362 20.7418 14.9949 20.743 16.6659V18H18.743V16.6671C18.7423 15.9077 18.2283 15.2448 17.493 15.0549L17.993 13.1184ZM14.833 7.05542C15.5705 7.24424 16.0863 7.90875 16.0863 8.67C16.0863 9.43126 15.5705 10.0958 14.833 10.2846L15.3291 12.2221C16.9515 11.8067 18.0863 10.3448 18.0863 8.67C18.0863 6.99524 16.9515 5.53333 15.3291 5.11792L14.833 7.05542Z"
        />
      </svg>
    );
  }
);
